import Vue from "vue";
import VueRouter from "vue-router";
import allroutes from "./routes";
import store from "../store";
import RootComponent from "@/components/RootComponent.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: `/`,
    component: RootComponent,
    children: allroutes,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name == "login") {
    localStorage.clear();
  }

  if (
    to.name != "login" &&
    to.name != "viewer" &&
    to.name != null &&
    from.name != null &&
    to.name != "mobile"
  ) {
    store.dispatch("auth/refreshUser");
  }

  if (to.meta.guest) next();
  else if (localStorage.getItem("user") == null) {
    next({
      name: "login",
    });
  } else {
    next();
  }
});

export default router;
